import createReducer from 'lib/createReducer';


export const CLOSE_FILTER_PANEL = 'CLOSE_FILTER_PANEL';
export const RESET_NOTEBOOK = 'RESET';
export const SAVE_FILTER_PANEL_STATE = 'SAVE_FILTER_PANEL_STATE';
export const SAVE_FILTER_MARKER_COLORS = 'SAVE_FILTER_MARKER_COLORS';
export const SAVE_NOTEBOOK_DISPLAY = 'SAVE_NOTEBOOK_DISPLAY';
export const SAVE_SORT_ORDER = 'SAVE_SORT_ORDER';


const initialState = {
  displayAnnotationColors: [],
  isFilterPanelOpen: false,
  sortOrder: 'Newest'
};

const notebook = createReducer(initialState, {
  [SAVE_SORT_ORDER]: (state, action) => {
    return { ...state, sortOrder: action.data };
  },

  [SAVE_FILTER_MARKER_COLORS]: (state, action) => {
    return { ...state, displayAnnotationColors: action.data };
  },

  [SAVE_NOTEBOOK_DISPLAY]: (state, action) => {
    return { ...state, ...action.data };
  },

  [SAVE_FILTER_PANEL_STATE]: (state, action) => {
    const { isFilterPanelOpen } = state;
    return { ...state, isFilterPanelOpen: !isFilterPanelOpen };
  },

  [CLOSE_FILTER_PANEL]: (state, action) => {
    return { ...state, isFilterPanelOpen: false };
  }
});


export default notebook;
